import { render, staticRenderFns } from "./PlanEmpty.vue?vue&type=template&id=b2b9433c&scoped=true&lang=pug&"
import script from "./PlanEmpty.vue?vue&type=script&lang=js&"
export * from "./PlanEmpty.vue?vue&type=script&lang=js&"
import style0 from "./PlanEmpty.vue?vue&type=style&index=0&id=b2b9433c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b9433c",
  null
  
)

export default component.exports